import { uuid, varchar, timestamp } from 'drizzle-orm/pg-core/columns';
import { pgTable } from 'drizzle-orm/pg-core/table';
import { commonFieldsWithSoftDelete } from './common-fields';
import { companies } from './companies';
import { relations } from 'drizzle-orm/relations';
import { InferSelectModel } from 'drizzle-orm/table';
import { CompanyUserRole } from './company-users';

export type CompanyInvite = InferSelectModel<typeof companyInvites>;

export const companyInvites = pgTable(
  'company_invites',
  {
    ...commonFieldsWithSoftDelete,
    role: varchar().notNull().$type<CompanyUserRole>().notNull(),
    email: varchar({ length: 255 }).notNull(),
    acceptedAt: timestamp(),
    companyId: uuid()
      .references(() => companies.id)
      .notNull(),
    // type: varchar({ length: 255 }).$type<FieldType>().notNull(),
    // longForm: boolean().default(false).notNull(),
    // templateRevisionId: uuid()
    //   .references(() => templateRevisions.id)
    //   .notNull(),
  },
  // table => {
  //   return [
  //     {
  //       idxCompanyInvitesCompany: index('idx_company_invites_company').using(
  //         'btree',
  //         table.companyId.asc().nullsLast(),
  //       ),
  //       // idxCompanyInvitesUser: index('idx_company_invites_user').using('btree', table.userId.asc().nullsLast()),
  //       // idxCompanyInvitesUserCompany: uniqueIndex('idx_company_invites_user_company').using(
  //       //   'btree',
  //       //   table.userId.asc().nullsLast(),
  //       //   table.companyId.asc().nullsLast(),
  //       // ),
  //       companyInvitesCompanyIdFkey: foreignKey({
  //         columns: [table.companyId],
  //         foreignColumns: [companies.id],
  //         name: 'company_invites_company_id_fkey',
  //       }),
  //       // companyInvitesUserIdFkey: foreignKey({
  //       //   columns: [table.userId],
  //       //   foreignColumns: [users.id],
  //       //   name: 'company_invites_user_id_fkey',
  //       // }),
  //     },
  //   ];
  // },
);

export const companyInvitesRelations = relations(companyInvites, ({ one }) => ({
  company: one(companies, {
    fields: [companyInvites.companyId],
    references: [companies.id],
  }),
}));
